/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { Mandate } from './mandate';

export type GenericApiResponseListMandateData = Mandate[] | null;
